<template>
  <div>
  {{ text }}
  </div>
</template>

<script>

export default {
  data() {
    return {
      text: 'Hallo!'
    };
  },
};
</script>
<style lang="scss" scoped>
</style>